import appConfig from 'react-global-configuration';
import Cons from '../../isomorphic/cons';

export default class PrimeHelper {
    static logIntoPropertyFile = (tcFile, returnPage) => {
        if (tcFile.originId > 0 || tcFile.transactionId > 0) {
            const data = {
                fileType: tcFile.isTransaction ? Cons.fileTypes.transaction : Cons.fileTypes.listing,
                fileId: tcFile.isTransaction ? tcFile.transactionId : tcFile.originId,
                email: tcFile.agents[0].email,
                contactId: tcFile.agents[0].agentContactId,
                returnPage: returnPage,
            };

            PrimeHelper.redirect(PrimeHelper.buildUrl(data));
        } else {
            PrimeHelper.logInAsAgent(tcFile.agents[0].email, tcFile.agents[0].agentContactId, returnPage);
        }
    };

    static logInAsAgent = (agentEmail, contactId, returnPage) => {
        const data = {
            fileType: 0,
            fileId: 0,
            email: agentEmail,
            contactId,
            returnPage: returnPage,
        };
        PrimeHelper.redirect(PrimeHelper.buildUrl(data));
    };

    static buildUrl = data => {
        let primeUrlBase = appConfig.get('SS_PRIME_URL');
        if (!data.returnPage) {
            data.returnPage = Cons.pages.files;
        }
        if (
            window.location.href.indexOf('skytcadmin-blue.skyslope.com') >= 0 ||
            window.location.href.indexOf('localhost')
        ) {
            data.returnPage = 'returnRoute';
            localStorage.setItem('aqbx-redirect-url', window.location.href);
        }

        return `${primeUrlBase}/login.aspx?FileType=${data.fileType}&FileId=${data.fileId}&Email=${data.email}&Source=${
            data.returnPage
        }&RedirectUrl=${btoa(appConfig.get('APP_ROOT_URL'))}&ContactId=${data.contactId}`;
    };

    static redirect = url => {
        window.location.replace(url);
    };
}



// WEBPACK FOOTER //
// ./src/utils/prime-helper.js